import { Box, Flex, Text } from '@cmpsr/components';
import AccountItem from '../common/account-item';

export type PaymentMethodProps = {
  cardLast4Digits: string;
  paymentFunding: string;
};

export default function PaymentMethod({ cardLast4Digits, paymentFunding }: PaymentMethodProps) {
  const maskedCardNumber = `**** **** **** ${cardLast4Digits}`;

  return (
    <Flex
      flexDirection="column"
      p={{ base: 'spacer-4', md: 'spacer-6' }}
      border="1px solid"
      borderColor="ui-element-divider"
      borderRadius="radii-3"
      backgroundColor="background-light"
      gap="spacer-4"
    >
      <Box display="flex" justifyContent="space-between">
        <Text variant="text-header-M">Payment Method</Text>
      </Box>
      <AccountItem label={`${paymentFunding} card`} value={maskedCardNumber} />
    </Flex>
  );
}
